'use strict';

require("core-js/modules/es6.function.name");

module.exports = function () {
  var i, colorPosition;
  var gradient = this.setDirection();
  var elToSetClassOnClass = document.querySelector(this.elToSetClassOn).classList;
  if (this.shouldClearCanvasOnEachFrame) this.context.clearRect(0, 0, this.x1, this.y1);

  if (this.image) {
    this.context.drawImage(this.imageNode, this.imagePosition.x, this.imagePosition.y, this.imagePosition.width, this.imagePosition.height);
  }

  for (i = 0; i < this.currentColors.length; i++) {
    // Ensure first and last position to be 0 and 100
    colorPosition = !i ? 0 : (1 / (this.currentColors.length - 1) * i).toFixed(2);
    gradient.addColorStop(colorPosition, 'rgba(' + this.currentColors[i][0] + ', ' + this.currentColors[i][1] + ', ' + this.currentColors[i][2] + ', ' + this.opacity[i] + ')');
  }

  if (this.name) {
    if (this.getLightness() === 'light') {
      elToSetClassOnClass.remove(this.name + '-dark');
      elToSetClassOnClass.add(this.name + '-light');
    } else {
      elToSetClassOnClass.remove(this.name + '-light');
      elToSetClassOnClass.add(this.name + '-dark');
    }
  }

  this.context.fillStyle = gradient;
  this.context.fillRect(0, 0, this.x1, this.y1);
};